import { Chart as ChartJS, BarElement, PointElement, LinearScale, CategoryScale, Title, Legend, } from 'chart.js';
import { Chart } from 'react-chartjs-2';

ChartJS.register( BarElement, PointElement, LinearScale, CategoryScale, Title, Legend );

export default function BirthdayBar( { data, height = 400 } ) {
    const labels = data.map( ( item ) => item.x );

    const chartData = {
        labels,
        datasets: [
          {
            type: 'bar',
            label: 'People',
            data: data.map((item) => item.total),
            borderColor: '#36A2EB',
            backgroundColor: '#36A2EB33',
            yAxisID: 'y1',
            tension: 0.4,
          }
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: 'index',
          intersect: false,
        },
        stacked: false,
        plugins: {
          title: {
            display: false,
            text: 'Birthday Distribution',
          },
          legend: {
            position: 'bottom',
            display: false
          },
        },
        scales: {
          x: {
            ticks: {
                // Angle always at 45 degrees
                minRotation: 20,
                maxRotation: 45,
                autoSkip: false, // optional: disables auto-skipping to preserve all ticks
            },
            title: {
                display: false,
                text: 'Month',
            },
          },
          y1: {
            type: 'linear',
            position: 'left',
            title: {
                display: true,
                text: 'People',
            },
            ticks: {
                stepSize: 1,
            }
          },
        },
    };

    return (
        <div style={{ position: 'relative', height: `${height}px`, width: '100%' }}>
            <Chart type='bar' data={chartData} options={options} />
        </div>
    );
}